'use client'
import React from 'react'

import { CtaLink } from '@/components/client/shared/buttons/cta'
import { useAnalytics, useTranslation } from '@/hooks/client'
import { abTranslationKey } from '@/lib/analytics/ab'
import { tw } from '@/lib/utils'
import { localizedHref } from '@/lib/utils/localized-href'

import { useNavContext } from './nav-context-provider'

export const NavCtaButton: React.FC = () => {
  const { segment } = useAnalytics()
  const navContext = useNavContext()
  const { t, locale } = useTranslation()

  const desktopTest = abTranslationKey({ test: 'nav-topbar-desktop', segment })
  const mobileTest = abTranslationKey({ test: 'nav-topbar-mobile', segment })

  const desktopText = t(desktopTest, 'View Top 10')
  const mobileText = t(mobileTest, 'Top Picks')
  const link = localizedHref(locale, '/best-hearing-aids')

  return (
    <section className="right flex min-h-[2.813rem] items-center justify-end gap-[10px]">
      {navContext.pageType === 'compare' ? (
        <div className="md:w-[165px]" />
      ) : (
        <CtaLink
          href={link}
          className={tw(
            'n4-topbar-button text-md h-[42px] min-h-0 min-w-29 shrink-0 px-6 py-3 leading-6 font-normal tracking-[-0.16px] whitespace-nowrap md:h-[46px]',
            navContext.isDarkNav && 'border border-white/15 hover:bg-sky-80 hover:text-navy'
          )}
          data-track="true"
          data-track-impression
          data-event-name="NavTopbarButton"
          data-event-test-desktop="nav-topbar-desktop"
          data-event-test-mobile="nav-topbar-mobile"
          data-event-position="nav-topbar"
          data-event-desktop-text={desktopText}
          data-event-mobile-text={mobileText}
          data-event-desktop-segment={segment}
          data-event-mobile-segment={segment}
          data-origin="nav"
        >
          <span className="text flex nav:hidden" key="btn-txt-mobile">
            {mobileText}
          </span>
          <span className="text--sm hidden nav:flex" key="btn-txt-full">
            {desktopText}
          </span>
        </CtaLink>
      )}
    </section>
  )
}
